import _regeneratorRuntime from "babel-runtime/regenerator";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import tadaWidgetFunctions from '../../../widgetFunctions/index';
var Base = {
    K: "K",
    M: "M",
    B: "B",
    DYNAMIC: "D"
};

var baseGridOptions = {
    rowHeight: 35,
    defaultColDef: {
        flex: 1,
        minWidth: 100,
        resizable: true
    },
    rowModelType: 'serverSide',
    serverSideInfiniteScroll: false,
    suppressAggFuncInHeader: true,
    cacheBlockSize: 500,
    animateRows: true
};

export var ReportWidget = function () {
    function ReportWidget(widgetConfig, el) {
        _classCallCheck(this, ReportWidget);

        this.widgetConfig = widgetConfig;
        this.reportConfig = widgetConfig.ReportWidgetConfig.ReportConfig;
        this.defaultLayout = this.reportConfig.defaultLayout;
        this.el = el;
        this.grid = null;
    }

    ReportWidget.prototype.render = function render() {
        this._processReportConfig();
        var gridOptions = this._getGridOptions();
        this.grid = new agGrid.Grid(this.el, gridOptions);
        gridOptions.api.setServerSideDatasource(this._gridDataSource());
    };

    ReportWidget.prototype._processReportConfig = function _processReportConfig() {
        var _processSections2 = this._processSections(),
            allGroups = _processSections2.allGroups,
            uniqueGroupNames = _processSections2.uniqueGroupNames;

        this.allGroups = allGroups;
        this.uniqueGroupNames = uniqueGroupNames;
        var summaryGroup = this.reportConfig.summary ? this.reportConfig.summary.summaryGroups[0] : null;
        if (summaryGroup) this._processSummaryGroups(summaryGroup);
        this.summaryGroup = summaryGroup;
    };

    ReportWidget.prototype._getGridOptions = function _getGridOptions() {
        var _this = this;

        var columnDefs = this.uniqueGroupNames.map(function (groupName) {
            return { field: groupName, rowGroup: true, hide: true, colId: groupName, grouptype: "group" };
        });
        if (this.summaryGroup) this._getSummaryColumnDefinitions(this.summaryGroup, columnDefs);

        var autoGroupColumnDef = columnDefs.length == 1 ? null : columnDefs[columnDefs.length - 1];
        if (columnDefs.length == 1) {
            columnDefs[0].hide = false;
            columnDefs[0].rowGroup = false;
            columnDefs[0].headerName = "Group";
        }
        if (columnDefs.length > 1) columnDefs.pop();

        this.reportConfig.valueFields.forEach(function (field) {
            var fieldName = field.title;
            if (field.propertyType.toLocaleLowerCase() == "property") fieldName = field.field.name;
            var textJustification = field.displaySettings != null && field.displaySettings.textJustification ? getTextJustification(field.displaySettings.textJustification) : "right";
            var headerJustification = field.displaySettings != null && field.displaySettings.textJustification ? getHeaderJustification(field.displaySettings.textJustification) : "text-right";
            columnDefs.push({
                headerClass: headerJustification,
                headerName: field.title,
                field: fieldName,
                aggFunc: field.aggregation,
                cellStyle: { textAlign: textJustification }
            });

            if (field.percentageFieldTitle && field.percentageFieldTitle != "") {
                columnDefs.push({
                    headerClass: headerJustification,
                    headerName: field.percentageFieldTitle,
                    field: field.percentageFieldTitle,
                    aggFunc: field.aggregation,
                    cellStyle: { textAlign: textJustification }
                });
            }
        });

        if (this.defaultLayout.computeColumns && this.defaultLayout.computeColumns.length > 0) {
            var _loop = function _loop(computeColumn) {
                var headerJustification = computeColumn.displaySettings != null && computeColumn.displaySettings.textJustification ? getHeaderJustification(computeColumn.displaySettings.textJustification) : "text-right";
                var textJustification = computeColumn.displaySettings != null && computeColumn.displaySettings.textJustification ? getTextJustification(computeColumn.displaySettings.textJustification) : "right";

                var computeColumnValueDefIndex = columnDefs.findIndex(function (c) {
                    return c.field == computeColumn.valueField;
                });
                var insertIndex = computeColumnValueDefIndex == -1 ? columnDefs.length : computeColumnValueDefIndex + 1;
                columnDefs.splice(insertIndex, 0, {
                    headerClass: headerJustification,
                    headerName: computeColumn.name,
                    cellStyle: { textAlign: textJustification },
                    field: computeColumn.name
                });
            };

            for (var _iterator = this.defaultLayout.computeColumns, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var computeColumn = _ref;

                _loop(computeColumn);
            }
        }

        var gridOptions = _extends({}, baseGridOptions, {
            columnDefs: columnDefs,
            autoGroupColumnDef: autoGroupColumnDef,
            groupAllowUnbalanced: true,
            onFirstDataRendered: function onFirstDataRendered(params) {
                params.columnApi.autoSizeAllColumns();
            },
            onRowGroupOpened: function onRowGroupOpened(params) {
                return _this._onRowGroupOpened(params);
            },
            getRowId: function getRowId(params) {
                return params.data.id;
            }
        });
        return gridOptions;
    };

    ReportWidget.prototype._onRowGroupOpened = function _onRowGroupOpened(params) {
        console.log('[onRowGroupOpened] - params: ', params);
        if (params.node.expanded) {
            if (params.node.rowGroupColumn.colDef.grouptype == "group") {
                var group = this._findGroup(params.node.field, params.node.id);
                this.activeGroup = group;
                this.activeGroupType = "group";
                this.activeLayoutGroup = group;
            } else if (params.node.rowGroupColumn.colDef.grouptype == "summary") {
                var _group = this._findSummaryGroup(params.node.rowGroupColumn.colDef.colId, this.summaryGroup);
                this.activeGroup = _group;
                this.activeGroupType = "summary";
            }
        }
    };

    ReportWidget.prototype._getSummaryColumnDefinitions = function _getSummaryColumnDefinitions(summaryGroup) {
        var columnDefs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        var summaryFieldName = summaryGroup.displayField ? summaryGroup.displayField.name : summaryGroup.field.name;
        columnDefs.push({ field: summaryFieldName, rowGroup: true, hide: true, grouptype: summaryGroup.type, colId: summaryGroup.field.name });
        if (summaryGroup.children != null && summaryGroup.children.length > 0) {
            var childGroup = summaryGroup.children[0];
            this._getSummaryColumnDefinitions(childGroup, columnDefs);
        }
    };

    // process sections and groups in sections and create parent relationships
    // and assign unique ids to each group


    ReportWidget.prototype._processSections = function _processSections() {
        var allGroups = [];
        for (var _iterator2 = this.defaultLayout.sections, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }

            var section = _ref2;

            var sectionClone = JSON.parse(JSON.stringify(section));
            sectionClone.groups = null;
            this._processSectionGroups(sectionClone, section.groups);
            allGroups = allGroups.concat(section.groups);
        }
        var uniqueGroupNames = this._getUniqueGroupNames(allGroups);
        return { allGroups: allGroups, uniqueGroupNames: uniqueGroupNames };
    };

    ReportWidget.prototype._processSectionGroups = function _processSectionGroups(baseSectionDetails, groups) {
        var parentGroup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        for (var _iterator3 = groups, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
            var _ref3;

            if (_isArray3) {
                if (_i3 >= _iterator3.length) break;
                _ref3 = _iterator3[_i3++];
            } else {
                _i3 = _iterator3.next();
                if (_i3.done) break;
                _ref3 = _i3.value;
            }

            var group = _ref3;

            group.section = baseSectionDetails;
            group.type = 'group';
            if (group.children && group.children.length > 0) {
                this._processSectionGroups(baseSectionDetails, group.children, group);
            }
        }
    };

    ReportWidget.prototype._processSummaryGroups = function _processSummaryGroups(summaryGroup) {
        var parentGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        summaryGroup.id = summaryGroup.field.name + '_summary';
        summaryGroup.type = 'summary';
        var summaryField = summaryGroup.field;
        if (summaryGroup.displayField) summaryField = _extends({}, summaryField, {
            displayId: summaryGroup.displayField.id,
            displayName: summaryGroup.displayField.name
        });
        summaryGroup.groupFields = [summaryField];
        if (parentGroup) summaryGroup.groupFields = [].concat(parentGroup.groupFields, summaryGroup.groupFields);
        if (summaryGroup.children && summaryGroup.children.length > 0) {
            for (var _iterator4 = summaryGroup.children, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
                var _ref4;

                if (_isArray4) {
                    if (_i4 >= _iterator4.length) break;
                    _ref4 = _iterator4[_i4++];
                } else {
                    _i4 = _iterator4.next();
                    if (_i4.done) break;
                    _ref4 = _i4.value;
                }

                var child = _ref4;

                this._processSummaryGroups(child, summaryGroup);
            }
        }
    };

    ReportWidget.prototype._getUniqueGroupNames = function _getUniqueGroupNames(allGroups) {
        var groupNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        for (var _iterator5 = allGroups, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
            var _ref5;

            if (_isArray5) {
                if (_i5 >= _iterator5.length) break;
                _ref5 = _iterator5[_i5++];
            } else {
                _i5 = _iterator5.next();
                if (_i5.done) break;
                _ref5 = _i5.value;
            }

            var group = _ref5;

            if (groupNames.indexOf(group.levelName) == -1) {
                groupNames.push(group.levelName);
            }
            if (group.children && group.children.length > 0) {
                this._getUniqueGroupNames(group.children, groupNames);
            }
        }
        return groupNames;
    };

    ReportWidget.prototype._findGroup = function _findGroup(levelName, groupId) {
        var groups = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.allGroups;

        var foundGroup = null;
        for (var _iterator6 = groups, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
            var _ref6;

            if (_isArray6) {
                if (_i6 >= _iterator6.length) break;
                _ref6 = _iterator6[_i6++];
            } else {
                _i6 = _iterator6.next();
                if (_i6.done) break;
                _ref6 = _i6.value;
            }

            var group = _ref6;

            if (group.levelName == levelName && group.id == groupId) {
                foundGroup = group;
            }
            if (foundGroup) break;
            if (group.children && group.children.length > 0) {
                foundGroup = this._findGroup(levelName, groupId, group.children);
                if (foundGroup) break;
            }
        }
        return foundGroup;
    };

    ReportWidget.prototype._findSummaryGroup = function _findSummaryGroup(groupName, summaryGroup) {
        var foundGroup = null;
        if (summaryGroup.field.name == groupName) foundGroup = summaryGroup;
        if (foundGroup) return foundGroup;
        if (summaryGroup.children && summaryGroup.children.length > 0) {
            var childGroup = summaryGroup.children[0];
            foundGroup = this._findSummaryGroup(groupName, childGroup);
            if (foundGroup) return foundGroup;
        }
        return foundGroup;
    };

    ReportWidget.prototype._getAllRootGroups = function _getAllRootGroups() {
        return this.allGroups.filter(function (group) {
            return group.levelName == "Level1";
        });
    };

    ReportWidget.prototype._gridDataSource = function _gridDataSource() {
        var self = this;
        return {
            getRows: function getRows(params) {
                var dataRequest = self._getDataRequest(params);
                dataRequest.model = self.widgetConfig.Model;
                dataRequest.context = self.widgetConfig.Context;
                var url = dataRequest.grouptype == "group" ? self.widgetConfig.ReportDataUrl : self.widgetConfig.DataFetchUrl;
                fetch(url, {
                    method: 'POST',
                    body: JSON.stringify(dataRequest),
                    headers: { "content-type": "application/json; charset=UTF-8" }
                }).then(function (response) {
                    if (response.ok) {
                        return response.json();
                    } else {
                        throw new Error(response.json());
                    }
                }).then(function (response) {
                    console.log(response);
                    if (!response || response.length == 0) {
                        params.success({ rowData: [], rowCount: 0 });
                        return;
                    }
                    var rows = self._convertToGridData(params, response, dataRequest);
                    params.success({ rowData: rows });
                    if (dataRequest.grouptype == "group") {
                        self._updateComputeColumns(params, self.defaultLayout.computeColumns);
                    }
                }).catch(function (error) {
                    console.log(error);
                    params.fail();
                });
            }
        };
    };

    ReportWidget.prototype._convertToGridData = function _convertToGridData(params, response, dataRequest) {
        var _this2 = this;

        var gridData = [];
        var propertyFields = this.reportConfig.valueFields.filter(function (v) {
            return v.propertyType.toLocaleLowerCase() == "property";
        }).map(function (v) {
            return { id: v.id, name: v.field.name };
        });
        if (dataRequest.grouptype == "group") {
            var groupIndex = 0;
            for (var _iterator7 = dataRequest.group.children, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
                var _ref7;

                if (_isArray7) {
                    if (_i7 >= _iterator7.length) break;
                    _ref7 = _iterator7[_i7++];
                } else {
                    _i7 = _iterator7.next();
                    if (_i7.done) break;
                    _ref7 = _i7.value;
                }

                var group = _ref7;

                var seriesData = response[group.title];
                for (var _iterator8 = seriesData, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
                    var _groupRow;

                    var _ref8;

                    if (_isArray8) {
                        if (_i8 >= _iterator8.length) break;
                        _ref8 = _iterator8[_i8++];
                    } else {
                        _i8 = _iterator8.next();
                        if (_i8.done) break;
                        _ref8 = _i8.value;
                    }

                    var item = _ref8;

                    var groupRow = (_groupRow = {}, _groupRow[group.levelName] = group.title, _groupRow.id = group.id, _groupRow.computeColumnDefs = group.computeColumnDefs, _groupRow);
                    var widgetFunctionFields = [];
                    for (var _iterator9 = this.reportConfig.valueFields, _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;) {
                        var _ref9;

                        if (_isArray9) {
                            if (_i9 >= _iterator9.length) break;
                            _ref9 = _iterator9[_i9++];
                        } else {
                            _i9 = _iterator9.next();
                            if (_i9.done) break;
                            _ref9 = _i9.value;
                        }

                        var valueField = _ref9;

                        if (valueField.propertyType.toLocaleLowerCase() !== "property") {
                            widgetFunctionFields.push(valueField);
                            continue;
                        }
                        var fieldValue = item[valueField.title];
                        groupRow[valueField.field.name] = fieldValue ? this._formatValue(valueField.format, fieldValue, group) : "--";
                        fieldValue = group.multiplier > 0 ? fieldValue * group.multiplier : fieldValue;
                        fieldValue = group.section.reverseSign ? fieldValue * -1 : fieldValue;
                        groupRow[valueField.field.name + "_raw"] = fieldValue;
                        if (!valueField.percentageFieldTitle) continue;
                        var parentLevel = valueField.percentageParentLevel == 0 ? 1 : valueField.percentageParentLevel;
                        var percentageValue = 100;
                        var percentageParentGroupData = this._getPercentageParentGroupData(params.parentNode, parentLevel, this.firstGroupData);
                        var denominatorValue = params.parentNode.key || parentLevel == -1 && groupIndex > 0 ? percentageParentGroupData[valueField.field.name + "_raw"] : fieldValue;
                        percentageValue = denominatorValue ? fieldValue / denominatorValue * 100 : 0;
                        groupRow[valueField.percentageFieldTitle] = percentageValue.toFixed(2) + "%";
                    }
                    if (widgetFunctionFields.length > 0) {
                        for (var _iterator10 = widgetFunctionFields, _isArray10 = Array.isArray(_iterator10), _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : _iterator10[Symbol.iterator]();;) {
                            var _ref10;

                            if (_isArray10) {
                                if (_i10 >= _iterator10.length) break;
                                _ref10 = _iterator10[_i10++];
                            } else {
                                _i10 = _iterator10.next();
                                if (_i10.done) break;
                                _ref10 = _i10.value;
                            }

                            var widgetFunctionField = _ref10;

                            var functionValue = tadaWidgetFunctions.calculateWidgetFunction(groupRow, widgetFunctionField.widgetFunction, propertyFields);
                            groupRow[widgetFunctionField.title] = functionValue ? this._formatValue(widgetFunctionField.format, functionValue) : "--";
                            groupRow[widgetFunctionField.title + "_raw"] = functionValue;
                            if (!widgetFunctionField.percentageFieldTitle) continue;
                            if (isNaN(functionValue)) {
                                groupRow[widgetFunctionField.percentageFieldTitle] = "--";
                                continue;
                            }
                            var parentLevel = widgetFunctionField.percentageParentLevel == 0 ? 1 : widgetFunctionField.percentageParentLevel;
                            var percentageValue = 100;
                            var percentageParentGroupData = this._getPercentageParentGroupData(params.parentNode, parentLevel, this.firstGroupData);
                            var denominatorValue = params.parentNode.key || parentLevel == -1 && groupIndex > 0 ? percentageParentGroupData[widgetFunctionField.title + "_raw"] : functionValue;
                            if (isNaN(denominatorValue)) {
                                groupRow[widgetFunctionField.percentageFieldTitle] = "--";
                                continue;
                            }
                            percentageValue = denominatorValue ? functionValue / denominatorValue * 100 : 0;
                            groupRow[widgetFunctionField.percentageFieldTitle] = percentageValue.toFixed(2) + "%";
                        }
                    }
                    if (groupIndex == 0 && group.levelName == "Level1") this.firstGroupData = groupRow;
                    gridData.push(groupRow);
                }
                groupIndex++;
            }
        } else if (dataRequest.grouptype == "summary") {
            var series = dataRequest.series[0];
            var _seriesData = response[0].data;
            if (!_seriesData || _seriesData.length == 0) return gridData;
            var groupData = _seriesData;
            var seriesGroup = dataRequest.group;
            for (var _iterator11 = groupData, _isArray11 = Array.isArray(_iterator11), _i11 = 0, _iterator11 = _isArray11 ? _iterator11 : _iterator11[Symbol.iterator]();;) {
                var _groupRow3;

                var _ref11;

                if (_isArray11) {
                    if (_i11 >= _iterator11.length) break;
                    _ref11 = _iterator11[_i11++];
                } else {
                    _i11 = _iterator11.next();
                    if (_i11.done) break;
                    _ref11 = _i11.value;
                }

                var _item = _ref11;

                if (!_item.aggregatedData || _item.aggregatedData.length == 0) continue;
                var _groupRow2 = (_groupRow3 = {}, _groupRow3[seriesGroup.field.name] = _item["group"], _groupRow3.id = seriesGroup.field.name + "_" + _item["group"], _groupRow3);
                if (seriesGroup.displayField) _groupRow2[seriesGroup.displayField.name] = _item["displayGroup"];
                var _widgetFunctionFields = [];

                var _loop2 = function _loop2(_valueField) {
                    if (_valueField.propertyType && _valueField.propertyType.toLocaleLowerCase() !== "property") {
                        _widgetFunctionFields.push(_valueField);
                        return "continue";
                    }
                    var seriesValueIndex = series.values.findIndex(function (v) {
                        return _valueField.propertyType && _valueField.propertyType.toLocaleLowerCase() == "property" && v.field.name == _valueField.field.name;
                    });
                    if (seriesValueIndex == -1) return "continue";
                    var fieldValue = _item.aggregatedData[seriesValueIndex];
                    _groupRow2[_valueField.field.name] = fieldValue ? _this2._formatValue(_valueField.format, fieldValue, dataRequest.layoutGroup) : "--";
                    fieldValue = dataRequest.layoutGroup.multiplier > 0 ? fieldValue * dataRequest.layoutGroup.multiplier : fieldValue;
                    fieldValue = dataRequest.layoutGroup.section.reverseSign ? fieldValue * -1 : fieldValue;
                    _groupRow2[_valueField.field.name + "_raw"] = fieldValue;
                    if (!_valueField.percentageFieldTitle) return "continue";
                    var parentLevel = _valueField.percentageParentLevel == 0 ? 1 : _valueField.percentageParentLevel;
                    var percentageValue = 100;
                    var percentageParentGroupData = _this2._getPercentageParentGroupData(params.parentNode, parentLevel, _this2.firstGroupData);
                    var denominatorValue = params.parentNode.key ? percentageParentGroupData[_valueField.field.name + "_raw"] : fieldValue;
                    percentageValue = denominatorValue ? fieldValue / denominatorValue * 100 : 0;
                    _groupRow2[_valueField.percentageFieldTitle] = percentageValue.toFixed(2) + "%";
                };

                for (var _iterator12 = this.reportConfig.valueFields, _isArray12 = Array.isArray(_iterator12), _i12 = 0, _iterator12 = _isArray12 ? _iterator12 : _iterator12[Symbol.iterator]();;) {
                    var _ref12;

                    if (_isArray12) {
                        if (_i12 >= _iterator12.length) break;
                        _ref12 = _iterator12[_i12++];
                    } else {
                        _i12 = _iterator12.next();
                        if (_i12.done) break;
                        _ref12 = _i12.value;
                    }

                    var _valueField = _ref12;

                    var _ret2 = _loop2(_valueField);

                    if (_ret2 === "continue") continue;
                }
                if (_widgetFunctionFields.length > 0) {
                    for (var _iterator13 = _widgetFunctionFields, _isArray13 = Array.isArray(_iterator13), _i13 = 0, _iterator13 = _isArray13 ? _iterator13 : _iterator13[Symbol.iterator]();;) {
                        var _ref13;

                        if (_isArray13) {
                            if (_i13 >= _iterator13.length) break;
                            _ref13 = _iterator13[_i13++];
                        } else {
                            _i13 = _iterator13.next();
                            if (_i13.done) break;
                            _ref13 = _i13.value;
                        }

                        var _widgetFunctionField = _ref13;

                        var _functionValue = tadaWidgetFunctions.calculateWidgetFunction(_groupRow2, _widgetFunctionField.widgetFunction, propertyFields);
                        _groupRow2[_widgetFunctionField.title] = _functionValue ? this._formatValue(_widgetFunctionField.format, _functionValue, dataRequest.layoutGroup) : "--";
                    }
                }
                gridData.push(_groupRow2);
            }
        }
        return gridData;
    };

    ReportWidget.prototype._formatValue = function _formatValue(format, value) {
        var group = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        if (value == null || isNaN(value) || isNaN(Number(value))) return null;
        if (!format) return toFixedString(value, 2);

        var decimalPlaces = format.decimalPlaces,
            isPercentage = format.isPercentage,
            removeCommas = format.removeCommas,
            base = format.base,
            prefix = format.prefix,
            suffix = format.suffix;


        var v = Number(value);
        var suf = suffix || '';

        switch (base) {
            case Base.K:
                v /= 1000;
                suf = suf ? "K " + suf : 'K';
                break;
            case Base.M:
                v /= 1000000;
                suf = suf ? "M " + suf : 'M';
                break;
            case Base.B:
                v /= 1000000000;
                suf = suf ? "B " + suf : 'B';
                break;
            case Base.DYNAMIC:
                if (v >= 1000 && v < 1000000 || v > -1000000 && v <= -1000) {
                    v /= 1000;
                    suf = suf ? "K " + suf : 'K';
                } else if (v >= 1000000 && v < 1000000000 || v > -1000000000 && v <= -1000000) {
                    v /= 1000000;
                    suf = suf ? "M " + suf : 'M';
                } else if (v >= 1000000000 || v <= -1000000000) {
                    v /= 1000000000;
                    suf = suf ? "M " + suf : 'B';
                }
                break;
        }

        if (isPercentage) {
            v *= 100;
            suf = suf ? "% " + suf : '%';
        }

        if (group) {
            v = group.multiplier > 0 ? v * group.multiplier : v;
            v = group.section.reverseSign ? v * -1 : v;
        }

        var valueString = toFixedString(v, decimalPlaces, removeCommas);

        return "" + (prefix || '') + valueString + suf;
    };

    ReportWidget.prototype._getDataRequest = function _getDataRequest(params) {
        var dataRequest = null;
        if (this.activeGroup == null) {
            var group = { children: [], grouptype: "group" };
            group.children = this._getAllRootGroups();
            dataRequest = this._getGroupDataRequest(group, params);
            dataRequest.group = group;
            dataRequest.grouptype = "group";
            return dataRequest;
        }
        if (this.activeGroupType == "group") {
            if (this.activeGroup.children && this.activeGroup.children.length > 0) {
                var _group2 = this.activeGroup;
                dataRequest = this._getGroupDataRequest(_group2, params);
                dataRequest.group = _group2;
                dataRequest.grouptype = this.activeGroupType;
                return dataRequest;
            } else {
                dataRequest = this._getSummaryGroupDataRequest(this.summaryGroup);
                dataRequest.grouptype = "summary";
                dataRequest.group = this.summaryGroup;
                dataRequest.layoutGroup = this.activeLayoutGroup;
                return dataRequest;
            }
        } else if (this.activeGroupType == "summary") {
            var _group3 = this.activeGroup.children[0];
            var parentPath = getSummaryGroupParentPath(params);
            dataRequest = this._getSummaryGroupDataRequest(_group3, parentPath);
            dataRequest.group = _group3;
            dataRequest.grouptype = this.activeGroupType;
            dataRequest.layoutGroup = this.activeLayoutGroup;
            return dataRequest;
        }
        return dataRequest;
    };

    ReportWidget.prototype._getGroupDataRequest = function _getGroupDataRequest(parentGroup, params) {
        var parentPath = getParentPath(params);
        var propertyValues = this.reportConfig.valueFields.filter(function (vf) {
            return vf.propertyType.toLocaleLowerCase() == "property";
        });
        var layoutDataRequest = {
            resourceName: this.reportConfig.service.name,
            resourceType: "Insight",
            fetchOptions: {
                contextFilters: this.widgetConfig.Context && JSON.parse(this.widgetConfig.Context).Filters,
                networkFilters: this.widgetConfig.NetworkFilters
            },
            layoutId: this.reportConfig.defaultLayout.id,
            layoutGroups: parentGroup.children,
            parentPath: parentPath,
            reportValues: propertyValues
        };
        return layoutDataRequest;
    };

    ReportWidget.prototype._getLayoutGroupsDataRequest = function _getLayoutGroupsDataRequest(layoutGroups, reportValues) {
        var parentPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        var layoutDataRequest = {
            resourceName: this.reportConfig.service.name,
            resourceType: "Insight",
            fetchOptions: {
                contextFilters: this.widgetConfig.Context && JSON.parse(this.widgetConfig.Context).Filters,
                networkFilters: this.widgetConfig.NetworkFilters
            },
            layoutId: this.reportConfig.defaultLayout.id,
            layoutGroups: layoutGroups,
            parentPath: parentPath,
            reportValues: reportValues
        };
        return layoutDataRequest;
    };

    ReportWidget.prototype._getSummaryGroupDataRequest = function _getSummaryGroupDataRequest(summaryGroup) {
        var parentPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var dataRequest = {
            application: this.widgetConfig.Model,
            series: [],
            useGSMApi: true,
            networkFilters: this.widgetConfig.NetworkFilters
        };
        var group = summaryGroup;
        var values = this.reportConfig.valueFields.reduce(function (result, vf) {
            if (vf.propertyType.toLocaleLowerCase() == "property") result.push({ field: vf.field, aggregation: vf.aggregation });
            return result;
        }, []);
        var requestFilter = JSON.parse(JSON.stringify(this.activeLayoutGroup.rules));
        if (parentPath) {
            var parts = parentPath.split("~");

            var groupFilter = {
                type: "group",
                group: "AND",
                items: []
            };

            var _loop3 = function _loop3(part) {
                var groupName = part.split(":")[0];
                var filterGroup = group.groupFields.find(function (gf) {
                    return gf.name == groupName;
                });
                if (!filterGroup) return "continue";
                var filter = {
                    type: "filter",
                    field: filterGroup,
                    comparison: "=",
                    values: [part.split(":")[1]]
                };
                if (parts.length > 1) groupFilter.items.push(filter);else groupFilter = { type: "filter", field: filterGroup, comparison: "=", values: [part.split(":")[1]] };
            };

            for (var _iterator14 = parts, _isArray14 = Array.isArray(_iterator14), _i14 = 0, _iterator14 = _isArray14 ? _iterator14 : _iterator14[Symbol.iterator]();;) {
                var _ref14;

                if (_isArray14) {
                    if (_i14 >= _iterator14.length) break;
                    _ref14 = _iterator14[_i14++];
                } else {
                    _i14 = _iterator14.next();
                    if (_i14.done) break;
                    _ref14 = _i14.value;
                }

                var part = _ref14;

                var _ret3 = _loop3(part);

                if (_ret3 === "continue") continue;
            }

            requestFilter.items.push(groupFilter);
        }
        dataRequest.series.push({
            name: group.id,
            service: this.reportConfig.service,
            filter: requestFilter,
            context: this.widgetConfig.Context,
            values: values
        });
        dataRequest.categories = [group.groupFields[group.groupFields.length - 1]];
        return dataRequest;
    };

    ReportWidget.prototype._getPercentageParentGroupData = function _getPercentageParentGroupData(parentNode, level) {
        var firstGroupData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        if (level == -1) {
            return firstGroupData;
        }

        if (!parentNode.key) {
            return parentNode.data;
        }
        var currentParentNode = parentNode;

        var parentLevel = 1;
        while (parentLevel < level) {
            currentParentNode = currentParentNode.parent;
            parentLevel++;
        }
        return currentParentNode.data;
    };

    ReportWidget.prototype._updateComputeColumns = function _updateComputeColumns(params, computeColumns) {
        var _this3 = this;

        var renderedRows = params.api.getRenderedNodes();
        if (!renderedRows) return;

        for (var _iterator15 = renderedRows, _isArray15 = Array.isArray(_iterator15), _i15 = 0, _iterator15 = _isArray15 ? _iterator15 : _iterator15[Symbol.iterator]();;) {
            var _ref15;

            if (_isArray15) {
                if (_i15 >= _iterator15.length) break;
                _ref15 = _iterator15[_i15++];
            } else {
                _i15 = _iterator15.next();
                if (_i15.done) break;
                _ref15 = _i15.value;
            }

            var renderedRow = _ref15;

            var groupComputeColumnDefs = renderedRow.data.computeColumnDefs;
            if (!groupComputeColumnDefs) continue;

            var _loop4 = function _loop4(computeColumn) {
                //find the group compute specific expression for a compute column
                var computeColumnDef = groupComputeColumnDefs.find(function (c) {
                    return c.columnId == computeColumn.id;
                });
                if (!computeColumnDef && computeColumn.referedColumnId) computeColumnDef = groupComputeColumnDefs.find(function (c) {
                    return c.columnId == computeColumn.referedColumnId;
                });
                if (!computeColumnDef) return "continue";
                _this3._renderRowComputeColumn(renderedRow, computeColumn, computeColumnDef, params);
            };

            for (var _iterator16 = computeColumns, _isArray16 = Array.isArray(_iterator16), _i16 = 0, _iterator16 = _isArray16 ? _iterator16 : _iterator16[Symbol.iterator]();;) {
                var _ref16;

                if (_isArray16) {
                    if (_i16 >= _iterator16.length) break;
                    _ref16 = _iterator16[_i16++];
                } else {
                    _i16 = _iterator16.next();
                    if (_i16.done) break;
                    _ref16 = _i16.value;
                }

                var computeColumn = _ref16;

                var _ret4 = _loop4(computeColumn);

                if (_ret4 === "continue") continue;
            }
        }
    };

    ReportWidget.prototype._renderRowComputeColumn = function () {
        var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(row, computeColumn, computeColumnDef, params) {
            var _this4 = this;

            var usedSectionsInCompute, usedGroupsInExpression, _loop5, _iterator17, _isArray17, _i17, _ref18, usedSection, _ret5, availableRowNodes, notAvailableGroups, _iterator18, _isArray18, _i18, _ref19, group, groupNode, value, valueField, dataRequest, url, response, requestResponse, layoutGroupsData, _iterator19, _isArray19, _i19, _ref20, _group4, groupData, _value;

            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            usedSectionsInCompute = computeColumnDef.usedSectionGroupsInOrder;
                            usedGroupsInExpression = [];
                            //gather all the layout groups used in the compute expression

                            if (!(usedSectionsInCompute && usedSectionsInCompute.length > 0)) {
                                _context.next = 21;
                                break;
                            }

                            _loop5 = function _loop5(usedSection) {
                                var sectionName = Object.keys(usedSection)[0];
                                var groupNames = usedSection[sectionName];
                                var section = _this4.defaultLayout.sections.find(function (s) {
                                    return s.name == sectionName;
                                });
                                if (!section) {
                                    row.setDataValue(computeColumn.name, "--");
                                    return "continue";
                                }
                                var currentGroup = section.groups.find(function (g) {
                                    return g.title == groupNames[0];
                                });
                                if (!currentGroup) {
                                    row.setDataValue(computeColumn.name, "--");
                                    return "continue";
                                }
                                if (groupNames.length > 1) {
                                    var reachedEndGroup = true;

                                    var _loop6 = function _loop6(index) {
                                        var groupName = groupNames[index];
                                        var childGroup = currentGroup.children.find(function (g) {
                                            return g.title == groupName;
                                        });
                                        if (!childGroup) {
                                            row.setDataValue(computeColumn.name, "--");
                                            reachedEndGroup = false;
                                            return "break";
                                        }
                                        currentGroup = childGroup;
                                    };

                                    for (var index = 1; index < groupNames.length; index++) {
                                        var _ret6 = _loop6(index);

                                        if (_ret6 === "break") break;
                                    }

                                    if (!currentGroup || !reachedEndGroup) {
                                        row.setDataValue(computeColumn.name, "--");
                                        return "continue";
                                    }
                                }

                                usedGroupsInExpression.push(currentGroup);
                            };

                            _iterator17 = usedSectionsInCompute, _isArray17 = Array.isArray(_iterator17), _i17 = 0, _iterator17 = _isArray17 ? _iterator17 : _iterator17[Symbol.iterator]();

                        case 5:
                            if (!_isArray17) {
                                _context.next = 11;
                                break;
                            }

                            if (!(_i17 >= _iterator17.length)) {
                                _context.next = 8;
                                break;
                            }

                            return _context.abrupt("break", 21);

                        case 8:
                            _ref18 = _iterator17[_i17++];
                            _context.next = 15;
                            break;

                        case 11:
                            _i17 = _iterator17.next();

                            if (!_i17.done) {
                                _context.next = 14;
                                break;
                            }

                            return _context.abrupt("break", 21);

                        case 14:
                            _ref18 = _i17.value;

                        case 15:
                            usedSection = _ref18;
                            _ret5 = _loop5(usedSection);

                            if (!(_ret5 === "continue")) {
                                _context.next = 19;
                                break;
                            }

                            return _context.abrupt("continue", 19);

                        case 19:
                            _context.next = 5;
                            break;

                        case 21:
                            availableRowNodes = [];
                            notAvailableGroups = [];

                            if (!(usedGroupsInExpression.length > 0)) {
                                _context.next = 40;
                                break;
                            }

                            _iterator18 = usedGroupsInExpression, _isArray18 = Array.isArray(_iterator18), _i18 = 0, _iterator18 = _isArray18 ? _iterator18 : _iterator18[Symbol.iterator]();

                        case 25:
                            if (!_isArray18) {
                                _context.next = 31;
                                break;
                            }

                            if (!(_i18 >= _iterator18.length)) {
                                _context.next = 28;
                                break;
                            }

                            return _context.abrupt("break", 40);

                        case 28:
                            _ref19 = _iterator18[_i18++];
                            _context.next = 35;
                            break;

                        case 31:
                            _i18 = _iterator18.next();

                            if (!_i18.done) {
                                _context.next = 34;
                                break;
                            }

                            return _context.abrupt("break", 40);

                        case 34:
                            _ref19 = _i18.value;

                        case 35:
                            group = _ref19;
                            groupNode = params.api.getRowNode(group.id);

                            if (groupNode) availableRowNodes.push(groupNode);else notAvailableGroups.push(group);

                        case 38:
                            _context.next = 25;
                            break;

                        case 40:
                            if (!(availableRowNodes.length == usedGroupsInExpression.length)) {
                                _context.next = 45;
                                break;
                            }

                            value = this._computeColumnValue(computeColumn, computeColumnDef, availableRowNodes);

                            row.setDataValue(computeColumn.name, value);
                            _context.next = 83;
                            break;

                        case 45:
                            valueField = this.reportConfig.valueFields.find(function (vf) {
                                return vf.field != null && vf.field.name == computeColumn.valueField;
                            });
                            dataRequest = this._getLayoutGroupsDataRequest(notAvailableGroups, [valueField]);
                            url = this.widgetConfig.ReportDataUrl;
                            _context.prev = 48;
                            _context.next = 51;
                            return fetch(url, {
                                method: 'POST',
                                body: JSON.stringify(dataRequest),
                                headers: { "content-type": "application/json; charset=UTF-8" }
                            });

                        case 51:
                            response = _context.sent;

                            if (!response.ok) {
                                _context.next = 77;
                                break;
                            }

                            _context.next = 55;
                            return response.json();

                        case 55:
                            requestResponse = _context.sent;
                            layoutGroupsData = [];
                            _iterator19 = notAvailableGroups, _isArray19 = Array.isArray(_iterator19), _i19 = 0, _iterator19 = _isArray19 ? _iterator19 : _iterator19[Symbol.iterator]();

                        case 58:
                            if (!_isArray19) {
                                _context.next = 64;
                                break;
                            }

                            if (!(_i19 >= _iterator19.length)) {
                                _context.next = 61;
                                break;
                            }

                            return _context.abrupt("break", 73);

                        case 61:
                            _ref20 = _iterator19[_i19++];
                            _context.next = 68;
                            break;

                        case 64:
                            _i19 = _iterator19.next();

                            if (!_i19.done) {
                                _context.next = 67;
                                break;
                            }

                            return _context.abrupt("break", 73);

                        case 67:
                            _ref20 = _i19.value;

                        case 68:
                            _group4 = _ref20;
                            groupData = requestResponse[_group4.title];

                            layoutGroupsData.push({ id: _group4.id, data: groupData });

                        case 71:
                            _context.next = 58;
                            break;

                        case 73:
                            _value = this._computeColumnValue(computeColumn, computeColumnDef, availableRowNodes, layoutGroupsData);


                            row.setDataValue(computeColumn.name, _value);
                            _context.next = 78;
                            break;

                        case 77:
                            row.setDataValue(computeColumn.name, "--");

                        case 78:
                            _context.next = 83;
                            break;

                        case 80:
                            _context.prev = 80;
                            _context.t0 = _context["catch"](48);

                            row.setDataValue(computeColumn.name, "--");

                        case 83:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this, [[48, 80]]);
        }));

        function _renderRowComputeColumn(_x10, _x11, _x12, _x13) {
            return _ref17.apply(this, arguments);
        }

        return _renderRowComputeColumn;
    }();

    ReportWidget.prototype._computeColumnValue = function _computeColumnValue(computeColumn, computeColumnDef) {
        var availableRowNodes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var groupsData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

        var expression = computeColumnDef.computeExpressionManipulated;
        if (availableRowNodes) {
            for (var _iterator20 = availableRowNodes, _isArray20 = Array.isArray(_iterator20), _i20 = 0, _iterator20 = _isArray20 ? _iterator20 : _iterator20[Symbol.iterator]();;) {
                var _ref21;

                if (_isArray20) {
                    if (_i20 >= _iterator20.length) break;
                    _ref21 = _iterator20[_i20++];
                } else {
                    _i20 = _iterator20.next();
                    if (_i20.done) break;
                    _ref21 = _i20.value;
                }

                var rowNode = _ref21;

                var rowColumnValue = rowNode.data[computeColumn.valueField + "_raw"];
                expression = expression.replaceAll("[" + rowNode.id + "]", rowColumnValue);
            }
        }
        if (groupsData) {
            var valueField = this.reportConfig.valueFields.find(function (vf) {
                return vf.field != null && vf.field.name == computeColumn.valueField;
            });
            for (var _iterator21 = groupsData, _isArray21 = Array.isArray(_iterator21), _i21 = 0, _iterator21 = _isArray21 ? _iterator21 : _iterator21[Symbol.iterator]();;) {
                var _ref22;

                if (_isArray21) {
                    if (_i21 >= _iterator21.length) break;
                    _ref22 = _iterator21[_i21++];
                } else {
                    _i21 = _iterator21.next();
                    if (_i21.done) break;
                    _ref22 = _i21.value;
                }

                var groupData = _ref22;

                var groupColumnValue = groupData.data[0][valueField.title];
                expression = expression.replaceAll("[" + groupData.id + "]", groupColumnValue);
            }
        }
        var value = void 0;
        try {
            value = eval(expression);
        } catch (e) {
            value = "--";
        }
        value = computeColumn.format ? this._formatValue(computeColumn.format, value) : value;
        return value;
    };

    return ReportWidget;
}();

function toFixedString(value, decimals) {
    var removeCommas = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var parsed = parseFloat(value.toFixed(decimals));
    return removeCommas ? parsed.toString() : parsed.toLocaleString('en');
}

function getTextJustification(textJustification) {
    switch (textJustification.toLocaleLowerCase()) {
        case "none":
            return "right";
        case "left":
            return "left";
        case "right":
            return "right";
        case "center":
            return "center";
        default:
            return "right";
    }
}

function getHeaderJustification(textJustification) {
    switch (textJustification.toLocaleLowerCase()) {
        case "left":
            return "text-left";
        case "center":
            return "text-center";
        case "none":
        case "right":
        default:
            return "text-right";
    }
}

function getParentPath(params) {
    var parentPath = [];
    var currentParent = params.parentNode;
    while (currentParent && currentParent.key) {
        parentPath.push(currentParent.key);
        currentParent = currentParent.parent;
    }
    return parentPath.join("~");
}

function getSummaryGroupParentPath(params) {
    var parentPath = [];
    var currentParent = params.parentNode;
    while (currentParent && currentParent.key && currentParent.rowGroupColumn.colDef.grouptype == "summary") {
        var fieldName = currentParent.rowGroupColumn.colDef.colId;
        parentPath.push(fieldName + ":" + currentParent.data[fieldName]);
        currentParent = currentParent.parent;
    }
    return parentPath.join("~");
}